import React from "react";
import "./Loader.scss";

function Loader() {
  return (
    <div className="containerLoader">
      <div className="loader" />
    </div>
  );
}

export default Loader;
